import styled from "styled-components";

const NoDataMessage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    font-size: var(--size-16);
    color: var(--color-grey-800);
    text-align: center;
    background: var(--color-grey-600);
    border-radius: var(--radius-10);
`;

export default NoDataMessage;
